import { createSelector } from "reselect"
import { get } from "lodash"
import { getQueryGroupBy } from "helpers/rollups"
import { getIsOpPro } from "modules/account-root/selectors"
import { getContentSets, getSelectedViewIsContentSet, getSelectedContentSetCategories, getSelectedContentSetDataType } from "selectors/contentSets"
import { computeAssetViewMenuItems, computeSubViewOptions, computeSelectedMetricType, computeContentSetFactorsFromCategories, computeSelectedSubView, computeMetricTypeOptions, computeSort, computeColumnOrderOptions } from "helpers/assets"
import { getSelectedView } from "selectors/assets"
import { getModelCategories } from "selectors/modelMetadata"
import { getBaseMetricTypeOptions } from "selectors/assets/metricTypes"
import { computeAttributionMethod } from "helpers/risk"
import { getDefaultMetricUnits } from "modules/default-metric-units/selectors"

export const getSelectedPage = state => get(state, "modules.assetAnalyticsTable.page")
export const getSelectedGroup = state => get(state, "modules.assetAnalyticsTable.selectedGroup")
export const getRawSelectedMetricType = state => get(state, "modules.assetAnalyticsTable.selectedMetricType")
export const getRawSelectedSubView = state => get(state, "modules.assetAnalyticsTable.selectedSubView")
export const getGrouping = (_, props) => props.currentGrouping
export const getRawSort = state => get(state, "modules.assetAnalyticsTable.sort")
export const getIsActive = (_, props) => props.isActive
export const getModelId = (_, props) => props.modelId
export const getAssetName = (_, props) => props.assetName
export const getViewType = (_, props) => props.viewType
export const getDisableColumnClick = (_, props) => get(props, "disableColumnClick", false)
const getAssetType = (_, props) => props.assetType

export const getMenuItems = createSelector(
  [getIsOpPro, getContentSets],
  (isOpPro, contentSets) => computeAssetViewMenuItems(isOpPro, contentSets, { includePerformance: true }),
)

export const getGroupingOptions = createSelector(
  [getGrouping, getIsActive],
  getQueryGroupBy,
)

export const getIdSort = createSelector(
  [getRawSort],
  computeSort,
)

export const getMetricTypeOptions = createSelector(
  [getBaseMetricTypeOptions, getSelectedView, getSelectedViewIsContentSet, getAssetType, getSelectedContentSetDataType, getDefaultMetricUnits],
  computeMetricTypeOptions,
)

export const getSelectedMetricType = createSelector(
  [getRawSelectedMetricType, getMetricTypeOptions],
  computeSelectedMetricType,
)

export const getSelectedPerformanceMetricType = createSelector(
  [getSelectedMetricType, getSelectedView, getDefaultMetricUnits],
  (selectedMetricType, selectedView, defaultMetricUnits) => {
    return selectedView === "summary" ? get(defaultMetricUnits, "performance") : selectedMetricType
  })

export const getSubViewOptions = createSelector(
  [getSelectedView, getSelectedContentSetCategories, getModelCategories, getSelectedViewIsContentSet],
  computeSubViewOptions,
)

export const getColumnOrderOptions = createSelector(
  [getSelectedView],
  computeColumnOrderOptions,
)

export const getSelectedSubView = createSelector(
  [getRawSelectedSubView, getSubViewOptions],
  computeSelectedSubView,
)

export const getContentSetCategoryFactors = createSelector(
  [getSelectedSubView, getSelectedContentSetCategories],
  computeContentSetFactorsFromCategories,
)

export const getAttributionMethod = createSelector(
  [getIsActive],
  computeAttributionMethod,
)
